import BaseApi from "./BaseApi";

class FyxApi extends BaseApi {
    constructor() {
        super('https://service.sanmanuela.net')
    }

    postRequest({ code, msg, data }: any) {
        if (code == 1) {
            return data
        }
        throw new Error(msg)
    }

    getAd() {
        return this.get(`/api/common/gg`, { flag: 'home' })
    }
}

export default new FyxApi()
